import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import FAQPage from '@/modules/faq-tc/faq';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/faq-tc/faq')({
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessFaqManagement } = useAccessControl();

  return canAccessFaqManagement ? <FAQPage /> : <AccessDenied />;
}
